import { atom } from "jotai";

import { IReceiptFilters } from "../models";

/** The register page's filter form — persisted so returning to a register
 * (or opening a modal and closing it) keeps it. Drives both the Z-reports
 * section and the receipts section below it. */
export const registerFiltersAtom = atom<IReceiptFilters | null>(null);
